import * as React from 'react';
import Typography from "@material-ui/core/Typography";
import {Box, Step, StepLabel, Stepper} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

// Create custom styles
const useStyles = makeStyles({
    stepLabel: {
        '& .MuiStepLabel-label': {
            fontSize: '13px',
            fontWeight: '300'
        },
        '& .MuiStepIcon-root': {
            fontSize: '22px'
        }
    }
});

const StepperFormTabs = ({ steps, active }) => {
    const classes = useStyles();

    return (
        <Box className={'margin-auto'}>
            <Stepper activeStep={active} style={{ background: 'whitesmoke' }}>
                {steps.map(({label, error}) => {
                    const labelProps = {};
                    if (error) {
                        labelProps.error = true;
                    }

                    return (
                        <Step key={label}>
                            <StepLabel
                                {...labelProps}
                                className={classes.stepLabel}
                            >
                                {label}
                            </StepLabel>
                        </Step>
                    );
                })}
            </Stepper>
        </Box>
    );
}


export default StepperFormTabs;